<template>
  <table id="table"  border="1" cellpadding="0" cellspacing="0" style="width:100%">
      <caption id="tablePrintText">
          <div style="font-weight:600;letter-spacing:0px">{{hotelInfo.name}}</div>
          <div style="font-weight:600">餐单消费明细表</div>
          <div style="display: flex;justify-content:space-between;">
              <div>
                <span style="font-weight:600" v-if="queryShiftValue != ''">班次:{{queryShiftValue == 1 ? '早班' : queryShiftValue == 2 ? '中班' :queryShiftValue == 3 ? '晚班':queryShiftValue == 4 ? '夜班':'所有' }} </span>
                <span style="font-weight:600">营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</span>
                  
              </div>
              <div>
                  <span style="font-weight:600">打印人:{{employee.name}}</span>
                  <span style="font-weight:600">打印时间:{{currentTime}}</span>
              </div>
          </div>
      </caption>
    <thead v-if="exportShow">
      <tr> <th :colspan="tabelTitel.length">{{hotelInfo.name}}</th></tr>
      <tr><th :colspan="tabelTitel.length">餐单消费明细表</th></tr>
      <tr>
        <th :colspan="tabelTitel.length/2">
          <div style="font-weight:600;textAlign:left">
            <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
          </div>
        </th>
        <th style="text-align:right" :colspan="(tabelTitel.length+1)/2">打印人:{{employee.name}}  打印时间:{{currentTime}}</th>
      </tr>
    </thead>
    <thead>
      <tr><th style="position:sticky;top:0;background-color:#fff;" v-for="th in tabelTitel" :key="th.code">{{th.chinese_desc}}</th></tr>
    </thead>
    <tbody>
      <tr v-for="tr in tabelList" :key="tr.code">
          <td align="center" v-for="(item,index) in tabelTitel" :key="index">{{item.code == 'people_count'?tr[item.code]:typeof(tr[item.code]) == 'number'?tr[item.code].toFixed(2):tr[item.code]}}</td>
      </tr>
      <tr v-if="tabelList.length > 0">
        <td align="center" v-for="(td,index) in sumsTotal" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
export default {
  props:{
    tabelTitel:{
      type:Array,
      default:[]
    },
    tabelList:{
      type:Array,
      default:[]
    },
    sumsTotal:{
      type:Array,
      default:[]
    },
    listQuery:{
      type:Object,
    },
    exportShow:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
       employee:localStorage.getItem('user'),
      currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
      hotelInfo:localStorage.getItem('hotel'),
      queryShiftValue: '',
    }
  },
  mounted(){
    this.$bus.$on('renderQueryShiftValue', val =>{
      this.queryShiftValue = val;
    });
  }

}
</script>